import PropTypes from 'prop-types';

import RichText from '../../../Core/RichText';

import { Wrapper, Header, Body, StyledImage } from './styles';

const DesktopProductStep = ({
  data = null,
  className = '',
  component = null,
}) => {
  if (!data) return null;

  const { id, heading, imageDam, textAlignment, bodyCopy } = data;

  return (
    <Wrapper key={id} className={`${className} ${component}`}>
      <Header className={textAlignment}>
        {heading && <RichText document={heading} />}
      </Header>
      {bodyCopy && (
        <Body>
          <RichText document={bodyCopy} />
        </Body>
      )}
      {imageDam && (
        <StyledImage
          key={imageDam.altText || ''}
          src={imageDam}
          alt=""
          objectFit="cover"
        />
      )}
    </Wrapper>
  );
};

DesktopProductStep.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
  component: PropTypes.string,
};

export default DesktopProductStep;
